import React, { Component } from "react";
import Header from "./Header";
import Footer from "./Footer";
export class TravelInsurance extends Component {
  render() {
    return (
      <div>
        <Header />
        <section id="contact">
          <div class="container-fluid" data-aos="fade-up">
            <br />
            <br />

            <div class="section-header">
              <h3>Travel Insurance At Best Rates</h3>
            </div>

            <div className="container">
              <form onSubmit={this.onSubmit}>
                <div class="row">
                  <div className="col-sm-4">
                    <select
                      name="gender"
                      className="form-control form-control-md"
                      onChange={this.onChange}
                    >
                      <option>Countries you are visiting?</option>
                    </select>
                  </div>

                  <div className="col-sm-4">
                    <select
                      name="gender"
                      className="form-control form-control-md"
                      onChange={this.onChange}
                    >
                      <option>Trip Start Date - Trip End Date</option>
                    </select>
                  </div>
                  <div className="col-sm-4">
                    <select
                      name="gender"
                      className="form-control form-control-md"
                      onChange={this.onChange}
                    >
                      <option>Add Travelers</option>
                    </select>
                  </div>
                </div>
                <br />
                <div class="row">
                  <div className="col-sm-6">
                    <input
                      type="text"
                      className="form-control form-control-md"
                      placeholder="Enter name"
                      name="name"
                      onChange={this.onChange}
                    />
                  </div>

                  <div className="col-sm-6">
                    <input
                      type="number"
                      className="form-control form-control-md"
                      placeholder="Mobile No"
                      name="name"
                      onChange={this.onChange}
                    />
                  </div>
                </div>

                <br />
                <p> I agree to the Disclaimers, Disclosures, Terms & Conditions and Privacy Policy 
</p>
                <div class="row">
                  <div className="col-sm-6"></div>

                  <div className="col-sm-6">
                    <button
                      variant="primary"
                      type="submit"
                      className="col-sm-6 btn btn-info"
                    >
                      View Quotes
                    </button>
                  </div>
                </div>

                <br />
              </form>
            </div>
          </div>
        </section>
        <Footer />
      </div>
    );
  }
}

export default TravelInsurance;
